// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledTypography } from "@insite/mobius/Link";
import { myAccountDashboardLinksStyles } from "@pace/App/Widgets/MyAccount/MyAccountDashboardLinks";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

myAccountDashboardLinksStyles.title = {
    variant: "h5",
    css: css`
        padding: 0 9px;
        margin-bottom: 8px;
    `,
};
myAccountDashboardLinksStyles.link = {
    typographyProps: {
        size: 14,
        lineHeight: "22px",
    },
    css: css`
        width: 100%;
        padding: 4px 8px;
        &:hover, &.active {
            ${StyledTypography} {
                color: ${color("primary.main")};
            }
            background-color: ${color("common.ui11")};
            border-radius: 4px;
        }
    `,
};
myAccountDashboardLinksStyles.container = {
    css: css`
        padding-bottom: 8px;
    `,
};
myAccountDashboardLinksStyles.linkWrapper = {
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        width: calc(100% - 17px);
        margin: 12px auto 12px;
    `,
};
